import React from 'react';
import Navbar from '../components/Navbar';
import ContactSection from '../components/ContactSection';

const GetInTouch = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="pt-24">
        <ContactSection />
      </div>
    </div>
  );
};

export default GetInTouch;


